module.exports = {
    common: require("./common"),
    activities: require("./activities"),
    hosting: require("./hosting")
};